import { URL_GENERAL_ERROR_500 } from "@/requests/general";
import MockAdapter from "axios-mock-adapter/types";

export const errorMock = (mock: MockAdapter): void => {
  mock.onGet(URL_GENERAL_ERROR_500).reply(500, {
    content: "test content",
  });
};

export default errorMock;
